import {create} from 'zustand'

export type UserEditingFieldsGroup =
    | 'personal-data'
    | 'job-data'
    | 'professional-data'
    | 'privacy'
    | 'contacts'
    | 'contractual-data'
    | 'availability'

type UserDetailsStore = {
    editingFieldsGroup: UserEditingFieldsGroup | null
    setEditingFieldsGroup: (value: UserEditingFieldsGroup | null) => void
    isErrorBannerVisible: boolean
    setIsErrorBannerVisible: (value: boolean) => void
    isContractTypeModalVisible: boolean
    setIsContractTypeModalVisible: (value: boolean) => void
}

export const useUserDetailsStore = create<UserDetailsStore>()(set => ({
    editingFieldsGroup: null,
    setEditingFieldsGroup: value => set({editingFieldsGroup: value}),
    isErrorBannerVisible: false,
    setIsErrorBannerVisible: value => set({isErrorBannerVisible: value}),
    isContractTypeModalVisible: false,
    setIsContractTypeModalVisible: value => set({isContractTypeModalVisible: value})
}))
